import React from 'react';
import {Modal, ModalHeader, ModalBody} from 'reactstrap';
import modalService from './modalService';

export const showAlertModal = ({message, header, icon}) => {
  modalService.requestModalV2({modal: <AlertModal message={message} header={header} icon={icon}/>})
};

export const showSuccessModal = message => showAlertModal({header: 'Success!', message, icon: 'check'});
export const showErrorModal = message => showAlertModal({header: 'Error', message, icon: 'alert'});

export const AlertModal = ({message, header, icon}) => {
  const headerTitle = header ? header : "Success";
  return <Modal isOpen={true} toggle={modalService.closeModal}>
    <ModalHeader toggle={modalService.closeModal}>{headerTitle}</ModalHeader>
    <ModalBody>
      <div className="text-center">
        <div style={{marginBottom: '40px', marginTop: '20px'}}>
          <span style={{fontSize: '40px'}} className={`ss ss-${icon}`}/>
        </div>
        <div style={{fontSize: '24px', marginBottom: '15px'}}>
          {header}
        </div>
        <div style={{marginBottom: '30px'}}>
          {Array.isArray(message) ? message.map((msg, index) => (<div key={`msg-${index}`}>{msg}</div>)) : message} {/* Allow for an array of messages to be delimited by lines */}
        </div>
      </div>
    </ModalBody>
  </Modal>
};
